/*=====================================================================*\
   @edited - Nov 2025
   - `shouldAppendToBody` attribute allows appending modal to body. This
      ensures we maintain fixed position relative to the viewport rather
      than Keen Slider which creates a new stacking context when using
      inline `transform` styles.
\*=====================================================================*/

class FullWidthMedia extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback();
  }

  setupListeners() {
    super.setupListeners();

    if (!this.els?.video?.exists) return;

    this.handleTrigger = this.handleTrigger.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger);
    });
    this.els.close.elements.forEach((close) => {
      this.listeners.add(close, 'click', this.handleClose);
    });
  }

  handleTrigger() {
    this.setAttribute('data-modal-open', 'true');
    document.body.classList.toggle('util-SiteOverflowed', true);

    const shouldAppendToBody = this.hasAttribute('data-append-modal-to-body');

    // Get modal + video elements dynamically
    let modalEl = this.els.modal?.element;
    let videoEl = this.els.video?.element;

    // If modal has been moved before, find it in body
    if (shouldAppendToBody && (!modalEl || !modalEl.isConnected)) {
      modalEl = document.querySelector(
        '[data-full-width-media-el="modal"][data-detached="true"]'
      );
      videoEl = modalEl?.querySelector('[data-full-width-media-el="video"]');
    }

    // Append modal to body if first time
    if (shouldAppendToBody && modalEl && !modalEl.dataset.detached) {
      this._originalParent = modalEl.parentNode;
      document.body.appendChild(modalEl);
      modalEl.dataset.detached = 'true';
    }

    if (!modalEl) return;
    modalEl.setAttribute('aria-hidden', 'false');

    if (!videoEl) return;

    for (const source of videoEl.children) {
      if (source.tagName === 'SOURCE') {
        source.src = source.dataset.src;
      }
    }

    videoEl.load();
    videoEl.play();
  }

  handleClose() {
    const shouldAppendToBody = this.hasAttribute('data-append-modal-to-body');

    const modalEl = shouldAppendToBody
      ? document.querySelector('[data-full-width-media-el="modal"][data-detached="true"]')
      : this.els.modal?.element;

    const videoEl = modalEl?.querySelector('[data-full-width-media-el="video"]');

    if (modalEl) {
      modalEl.setAttribute('aria-hidden', 'true');
    }

    document.body.classList.toggle('util-SiteOverflowed', false);
    videoEl?.pause();

    // Return modal to original parent
    if (shouldAppendToBody && modalEl && this._originalParent) {
      this._originalParent.appendChild(modalEl);
      modalEl.removeAttribute('data-detached');
    }
  }
}

if (!customElements.get('full-width-media')) {
  customElements.define('full-width-media', FullWidthMedia);
}